import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link, useHistory } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import {
  getOrderCoinDcx,
  getUser,
  getUserWalletTrx,
} from "../../../service/api";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import moment from "moment";
import { toast } from "react-toastify";
import { message } from "antd";
import { triggerDownload } from "../../../config/downloadUtils";
import { IoClose, IoCopyOutline } from "react-icons/io5";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { sanitizeInput } from "../../../config/validation";
import Select from "react-select";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

const shortenAddress = (addr) => {
  return addr?.length > 10 ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : addr;
};

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  message.success("Copied to clipboard!");
};

const ALL_COLUMNS = [
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (row) => (
      <div>
        {row?.userDetails?.firstName} {row?.userDetails?.lastName}
        <br />
        <small style={{ color: "#6c757d" }}>{row?.userDetails?.email}</small>
      </div>
    ),
  },
  {
    key: "_id",
    title: "User _id",
    defaultVisible: false,
    render: (row) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{row?.userDetails?._id || "-"}</span>,
  },
  {
    key: "userId",
    title: "User ID",
    defaultVisible: false,
    render: (row) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{row?.userDetails?.userId?.toUpperCase() || "-"}</span>,
  },
  {
    key: "transactionId",
    title: "Transaction ID",
    defaultVisible: true,
    render: (row) => (
      <div className="d-flex align-items-center gap-2">
        <span>{shortenAddress(row?.transactionId)}</span>
        <IoCopyOutline
          style={{ cursor: "pointer" }}
          onClick={() => copyToClipboard(row?.transactionId)}
        />
      </div>
    ),
  },
  {
    key: "coin",
    title: "Coin",
    defaultVisible: true,
    render: (row) => (
      <div className="d-flex align-items-center gap-2">
        {row?.coinDetails?.image && (
          <img
            src={row?.coinDetails?.image}
            alt={row?.coinDetails?.symbol}
            style={{ width: "24px", height: "24px", borderRadius: "50%" }}
          />
        )}
        <div>
          <div>{row?.coinDetails?.symbol}</div>
          <small style={{ color: "#6c757d" }}>{row?.coinDetails?.name}</small>
        </div>
      </div>
    ),
  },
  {
    key: "amount",
    title: "Amount",
    defaultVisible: true,
    render: (row) => (
      <div>
        <span style={{ fontWeight: "500" }}>
          {row?.amount} {row?.coinDetails?.symbol}
        </span>
      </div>
    ),
  },
  {
    key: "type",
    title: "Type / SubType",
    defaultVisible: true,
    render: (row) => (
      <div>
        <span
          className={`badge ${row?.type === "CREDIT" ? "bg-success" : "bg-danger"}`}
          style={{ fontSize: "11px" }}
        >
          {row?.type}
        </span>
        <br />
        <small style={{ color: "#6c757d" }}>{row?.subType}</small>
      </div>
    ),
  },
  {
    key: "trxStatus",
    title: "Status",
    defaultVisible: true,
    render: (row) => (
      <span
        className={`badge ${
          row?.trxStatus === "COMPLETED"
            ? "bg-success"
            : row?.trxStatus === "PENDING"
            ? "bg-warning"
            : "bg-danger"
        }`}
      >
        {row?.trxStatus}
      </span>
    ),
  },
  {
    key: "fromAddress",
    title: "From Address",
    defaultVisible: false,
    render: (row) => (
      <div className="d-flex align-items-center gap-2">
        <span>{shortenAddress(row?.fromAddress)}</span>
        {row?.fromAddress && (
          <IoCopyOutline
            style={{ cursor: "pointer" }}
            onClick={() => copyToClipboard(row?.fromAddress)}
          />
        )}
      </div>
    ),
  },
  {
    key: "toAddress",
    title: "To Address",
    defaultVisible: false,
    render: (row) => (
      <div className="d-flex align-items-center gap-2">
        <span>{shortenAddress(row?.toAddress)}</span>
        {row?.toAddress && (
          <IoCopyOutline
            style={{ cursor: "pointer" }}
            onClick={() => copyToClipboard(row?.toAddress)}
          />
        )}
      </div>
    ),
  },
  {
    key: "txHash",
    title: "Tx Hash",
    defaultVisible: false,
    render: (row) => (
      <div className="d-flex align-items-center gap-2">
        <span>{shortenAddress(row?.txHash)}</span>
        {row?.txHash && (
          <IoCopyOutline
            style={{ cursor: "pointer" }}
            onClick={() => copyToClipboard(row?.txHash)}
          />
        )}
      </div>
    ),
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: true,
    render: (row) =>
      row?.createdAt ? moment(row.createdAt).format("DD/MM/YYYY HH:mm") : "-",
  },
];

const WalletTrx = () => {
  const history = useHistory();
  const [trxList, setTrxList] = useState(null);
  const [user, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [coin, setCoin] = useState("");
  const [coinOptions, setCoinOptions] = useState([]);
  const [userId, setUsersId] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "wallet-list",
    allColumns: ALL_COLUMNS,
  });

  const getUserList = () => {
    let body = {
      page: page,
      sizePerPage: 10,
      pagination: false,
    };

    getUser(body)
      .then((res) => {
        if (res?.status) {
          const data = [];
          res?.data?.result?.map((item) => {
            data.push({
              value: item?._id,
              label: `${item?.firstName} ${item?.lastName}`,
            });
          });
          setUsers(data);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const getCoinList = () => {
    getOrderCoinDcx({ pagination: false })
      .then((res) => {
        if (res?.status) {
          const list = res?.data?.result || res?.data || [];
          const opts = list.map((c) => ({
            value: c?._id || c?.symbol,
            label: c?.symbol || c?.name,
          }));
          setCoinOptions(opts);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getUserList();
    getCoinList();
  }, []);

  const getTrxList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (userId) {
      body.userId = userId?.value;
    }
    if (type) {
      body.type = type?.value;
    }
    if (coin) {
      body.coin = coin?.value;
    }
    if (search) {
      body.search = search;
    }
    if (startDate && endDate) {
      body.startDate = startDate;
      body.endDate = endDate;
    }

    setLoading(true);
    getUserWalletTrx(body)
      .then((res) => {
        console.log("%c Line:52 🍞 res", "color:#93c0a4", res);
        if (res?.status) {
          setTrxList(res);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (userId) body.userId = userId?.value;
    if (type) body.type = type?.value;
    if (coin) body.coin = coin?.value;
    if (search) body.search = search;
    if (startDate && endDate) {
      body.startDate = startDate;
      body.endDate = endDate;
    }
    setDownloadLoading(true);
    getUserWalletTrx(body)
      .then((res) => {
        const result = res?.data?.result ?? res?.data ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "wallet-transactions");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  useEffect(() => {
    getTrxList();
  }, [page, pageSize, userId, startDate, endDate, search, type, coin]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, userId, startDate, endDate, search, type, coin]);

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end d-flex justify-content-end gap-1">
        <a
          onClick={() => {
            history.push(`/admin/wallet/${row?._id}`);
          }}
          className="btn btn-sm bg-primary-light"
        >
          <CiViewList /> View details
        </a>
        {row?.userDetails?._id && (
          <a
            onClick={() => {
              history.push(`/admin/wallet/${row.userDetails._id}/transactions`);
            }}
            className="btn btn-sm bg-success-light"
          >
            User History
          </a>
        )}
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Wallet Transaction </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    Wallet Transaction{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card">
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={trxList?.pagination?.totalRecords}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin
                          size="large"
                          style={{ position: "relative", top: "35%" }}
                        />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={trxList ? trxList?.data : []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {trxList &&
                      trxList?.pagination?.totalRecords > pageSize && (
                        <CustomPagination
                          key={`pg-${pageSize}`}
                          totalTabs={trxList?.pagination?.totalRecords}
                          tabsPerPage={pageSize}
                          handleChange={setPage}
                          className={`${
                            loading ? "display-hide" : "display-flex"
                          }`}
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="list-layout__filters">
              <FilterPanel
                onClear={() => {
                  setType("");
                  setCoin("");
                  setUsersId("");
                  setSearch("");
                  setStartDate();
                  setEndDate();
                }}
              >
                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(sanitizeInput(e?.target?.value))}
                    placeholder="Address or txHash"
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Type">
                  <Select
                    options={[
                      { label: "Credit", value: "CREDIT" },
                      { label: "Debit", value: "DEBIT" },
                    ]}
                    value={type || null}
                    onChange={(option) => setType(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isSearchable={false}
                    isClearable
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Coin">
                  <Select
                    options={coinOptions}
                    value={coin || null}
                    onChange={(option) => setCoin(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="User">
                  <Select
                    options={user}
                    value={userId || null}
                    onChange={(option) => setUsersId(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isSearchable={false}
                    isClearable
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Date Range">
                  <DateRangePicker
                    onApply={handleDateRangeChange}
                    isClearable={true}
                  >
                    <input
                      type="text"
                      placeholder="Select date range"
                      readOnly
                    />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletTrx;
